module.exports = __webpack_public_path__ + "img/base_activites_loisir.8cdb07a2.svg";